type State = {
  loading: boolean;
  error: Error | null;
  ready: boolean;
};

type Loading = {
  type: 'LOADING';
};

type Success = {
  type: 'SUCCESS';
};

type Err = {
  type: 'ERROR';
  error: Error | null;
};

export type Action = Loading | Success | Err;

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'LOADING':
      return {
        loading: true,
        error: null,
        ready: false,
      };
    case 'SUCCESS':
      return {
        loading: false,
        error: null,
        ready: true,
      };
    case 'ERROR':
      return {
        loading: false,
        error: action.error,
        ready: true,
      };
    default:
      return state;
  }
}
